import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@app/shared/utils/common';

const variants = cva('animate-loading rounded-full', {
  variants: {
    variant: {
      accent: 'border-accent',
      orange: 'border-orange-500',
    },
    size: {
      xs: 'h-4 w-4 border-2',
      md: 'h-9 w-9 border-[3px]',
      lg: 'h-16 w-16 border-4',
    },
  },
  defaultVariants: {
    variant: 'accent',
    size: 'md',
  },
});

interface LoadingSpinnerProps extends VariantProps<typeof variants> {
  containerClassName?: string;
  mode?: 'inline' | 'overlay';
}

export function LoadingSpinner({
  containerClassName,
  variant,
  size,
  mode = 'inline',
}: LoadingSpinnerProps) {
  const isOverlay = mode === 'overlay';

  return (
    <div
      className={cn(
        containerClassName,
        isOverlay
          ? 'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center'
          : 'flex items-center justify-center h-full w-full'
      )}
    >
      <span
        className={cn(variants({ variant, size }), 'border-b-transparent block animate-loading')}
      />
    </div>
  );
}
